import Bestamp from "../components/Bestamp";
import useBestamp from "../hooks/useBestamp";

const BestampPages = () => {
    const BestampProps = useBestamp();
    return <Bestamp {...BestampProps}/>
};

export default BestampPages;